// extracted by mini-css-extract-plugin
export default {"placeholder":"Messages_placeholder__hj5cL","message":"Messages_message__QY1WP","closeMessageBtn":"Messages_closeMessageBtn__hTTQv"};